<template lang="pug">
    .landingpage
        .section.header(v-if="headerSections.length" v-for="(section, index) in headerSections" :key="section.id" :class="section.key")
            Banner(v-if="section.key === 'banner'" :section="section")
            Slider(v-if="section.key === 'slider'" :section="section")
        .section.body(v-if="mainSections.length" v-for="(section, index) in mainSections" :key="section.id" :class="section.key")
            Heading(
                v-if="section.key === 'heading'" :section="section"
                heading-class="is-size-2-desktop is-size-3-tablet is-size-4-mobile has-text-weight-light"
                sub-heading-class="is-size-6 is-uppercase has-text-primary"
            )
            Slider(v-if="section.key === 'slider'" :section="section")
            CategoryPosts(
                v-if="section.key === 'categoryposts'"
                :section="section"
                :per-page="4"
                orientation="horizontal"
            )
            ImageSection(v-if="section.key === 'image'" :section="section")
            Post(v-if="section.key === 'post'" :section="section")
</template>

<script>

// import _ from 'lodash'
import { mapGetters } from 'vuex'

import Heading from '@/components/Heading'
import Slider from '@/components/Slider'
import ImageSection from '@/components/ImageSection'
import CategoryPosts from '@/components/CategoryPosts'
import Post from '@/components/Post'
import Banner from '@/components/Banner'

export default {
    name: 'LandingPage',
    components: {
        Heading,
        Slider,
        ImageSection,
        CategoryPosts,
        Post,
        Banner,
    },
    computed: {
        headerSections() {
            return this.filteredSections.filter(section => section.area === 'header')
        },
        mainSections() {
            return this.filteredSections.filter(section => section.area === 'main')
        },
        filteredSections() {
            return this.sections.filter(section => {
                return section.key === 'heading'
                    || section.key === 'slider'
                    || section.key === 'categoryposts'
                    || section.key === 'image'
                    || section.key === 'post'
                    || section.key === 'banner'
            })
        },
        ...mapGetters('currentPage', {
            sections: 'sections',
        })
    }
}

</script>

<style lang="sass" scoped>
    .section.slider,
    .section.banner
        padding: 0
    .section.heading
        padding-bottom: 0
</style>
